export const BasePath = 'https://homeandsoul.com/admin-portal/api';